<script>
    import { scaleLinear, max, selectAll} from "d3";
    import DistPlot from './DistPlot.svelte';
	import Select from 'svelte-select';
    import { showGlobalTick, infoPopup, instructions, beeSwarmData } from "../shared/stores.js";

    export let innerHeight;
    export let innerWidth;
    export let mainBgColor;
    export let mainDrawColor;
    export let mainBgColorControls;
    export let mainBorderColor;
    export let mainSpecialColor;
    export let mainTitleColor;
    export let darkMode;
    export let headerItemsMargins;
    export let distPlotWidthRatio;
    export let map;
    export let metroData;
	export let aggData;
    export let getRscale;
    export let radius;
    export let accessScale;
    export let walkingTime;
    export let mapboxgl;
    export let pageID;
    export let zoom;
    export let borderWidthBoxes;
    export let borderWidthTooltip;
    export let borderWidthButtons;
	export let borderWidthSearch;
	export let mainSpecialColorActive;
    export let boxShadow;
    export let mainSvgColor;
	export let options;
	export let groupBy;

    // export let infoPopup;
    
    // $: selectedCity = pageID===2

    $: showGlobalTick.set(zoom<2.3&&(pageID>=globalTickPage||$instructions===false)?true:false);
	$: beeSwarmData.set(countryData!==null && $showGlobalTick===false?countryData:metroData);
	// $: console.log(countryData!==null&&showGlobalTick===false)
	// $: console.log(countryData)
	// $: console.log(showGlobalTick)
    // $: showSearchBar.set(pageID>=4||$instructions===false?true:false)

    // text:`<p style="color:${darkMode===true?"white":mainTitleColor};margin-top:${textTopMargin}px;font-weight:500px;font-size:20px;"> The 15 Minute City is real! Cities all over the world are working towards it. But, which cities are leading this change? Which cities need to invest in public infrastructure to improve access to services for their residents?</p>`},

    $: pages = [{label:"intro", text:`The <i>15 Minute City</i> is real! Cities all over the world are working to provide their residents with services that are accessible within a 15 minute walk. <br><br> But, which cities are leading this change? Which cities need to invest in public infrastructure to improve access to services for their residents?`},
                 {label:"description", text:`<b>CITY<span style="color:${mainSpecialColor}">ACCESS</span>MAP</b>, was developed to provide public administrations, metropolitan authorities, municipalities, NGOs, private organizations, and residents, with the necessary tools to answer these questions. It's an open source app for global-scale urban accessibility insights. As of today, it covers (nearly) any urban area with more than 100,000 residents, worldwide, and computes walking accessibility down to the city block level. It can answer both macro-level and micro-level questions.`},
                 {label:"BogotaExample", text:`For example, accessibility data shows that <span style="color:${mainSpecialColor}"><b>Bogota, Colombia</b></span>, is one of the most accessible cities in the world. It's also the most accessible city in Colombia. <span style="color:${mainSpecialColor}"><b>100%</b></span> of its residents have access to services within a 15 minute walk.`},
                 {label:"OrlandoExample", text:`Conversely, <span style="color:${mainSpecialColor}"><b>Orlando, United States</b></span>, is among the least accessible cities in the U.S., and in the world. There, only <span style="color:${mainSpecialColor}"><b>7%</b></span> of residents have access to services within a 15 minute walk. As you can see below, accessibility varies quite alot in the United States. We find cities that score on all parts of the spectrum.`},
				 {label:"ParisExample", text:`Other countries show much less variability. For example, while accessibility is very high in <span style="color:${mainSpecialColor}"><b>Paris, France</b></span>, french cities are always associated with high levels of accessibility.`},
				 {label:"UserExample", text:`Finally here's how your city, <span style="color:${mainSpecialColor}"><b>${userCityName}</b></span>, scores on accessibility.`},
                 {label:"UIDescriptionDistplot", text:`So how do we use this tool? On top of the screen <span class="material-symbols-outlined">arrow_upward</span> you can see how accessibility is distributed across the world's largest cities (i.e. where pop. >= 500,000). <span style="transform:translate(0px,5px)" class="material-symbols-outlined">touch_app</span> Hover over a circle (i.e. city) to quickly navigate to that city.`},
                 {label:"UIDescriptionSearch", text:`You can also search for a city using the search bar on the top right of the screen, or simply by zooming <span class="material-symbols-outlined">zoom_in</span> around the map and clicking on a specific city.`},
                 {label:"consoleDescription", text:`Finally, when viewing a specific city, you can adjust the weight that each service is given using the <span class="material-symbols-outlined">tune</span> sliders in the console.`}].filter(d=>showUserExample===true?d:d.label!=="UserExample")
                 
    $: selectedPage = pages[pageID]

    $: boxHeight = innerHeight*0.57;
    $: boxWidth = innerWidth<640?innerWidth*distPlotWidthRatio-headerItemsMargins:400;
	$: distPlotWidth = innerWidth<640?boxWidth*0.92:boxWidth*0.95
    $: boxyOffset = innerHeight*0.52-(innerHeight*0.55/2);
    $: textTopMargin = boxHeight*0.1;
    $: buttonsMargin = pageID===0?7+50:7;

    $: distanceToNormGlobe = scaleLinear()
						   .domain([0, max(aggData, d=>d.mobility)])
						   .range([1,0])

    // fly to city on example
    $: selectedCityName = selectedPage.label==="BogotaExample"?"Bogota, Colombia":selectedPage.label==="OrlandoExample"?"Orlando, United States":selectedPage.label==="ParisExample"?"Paris, France":selectedPage.label==="consoleDescription"?"Batumi, Georgia":selectedPage.label==="UserExample"?userCityName:null;
    $: selectedCityData = selectedCityName!==null?aggData.filter(d=>d.UC_NM_CTR===selectedCityName):null;
    $: selectedCountry = selectedCityName!==null?selectedCityData[0].CTR_MN_NM:null;
    $: countryData = selectedCityName!==null?aggData.filter(d=>d.CTR_MN_NM===selectedCountry):null;
    $: fifteenMinProp = selectedCityName!==null?(selectedCityData[0].fifteenPopAccess/selectedCityData[0].P15).toFixed()>100?100:(selectedCityData[0].fifteenPopAccess/selectedCityData[0].P15).toFixed():null;
    $: rScale = selectedCityName!==null?getRscale(countryData, radius, innerWidth):null;
	$: userCity = null;
	$: userCityName = null;
	$: userCountry = null;
	$: showUserExample = userCityName!==null?true:false;
	$: globalTickPage = showUserExample===true?6:5

    // $: console.log(selectedCityData)
    // $: console.log(selectedCountry)
    // $: console.log(countryData)
    // $: console.log(fifteenMinProp)

    $: if (selectedCityData!==null) {
        flyToCity(map, selectedCityData[0])
        if (innerWidth>640&&selectedPage.label!=="consoleDescription") {
            showTooltipGlobe(selectedCityData[0])
        }
    }

    $: if (pageID===globalTickPage) {
        selectAll(".mapboxgl-popup").remove()
    }

    function flyToCity(map, selection) {
		
		// const selectionData = data.filter(d=>d.ID_HDC_G0===selection)
		// console.log("selectionData", selectionData)
		const coords = innerWidth>640?[selection.lng-18, selection.lat]:[selection.lng, selection.lat]
		
		// NEW METHOD
		map.flyTo({
						center: coords,
						essential: true,
						zoom:1.7,
						// maxZoom: 12,
						// minZoom: 9,
						// speed: 0.5, // make the flying slow
						// curve: 1, // change the speed at which it zooms out
					})
    }

    function showTooltipGlobe(selection) {

        const coords = [selection.lng, selection.lat]
        const cityData = selection
		const cityfifteenMinProp = (cityData.fifteenPropAccess).toFixed()>100?100:(cityData.fifteenPropAccess).toFixed()
		const accessValue = cityData.accessibility
		const accessNormValue = distanceToNormGlobe(accessValue)
		const color = accessScale(accessNormValue)
		// console.log(accessNormValue)
		selectAll(".mapboxgl-popup").remove()

		new mapboxgl.Popup()
			.setLngLat(coords)
			.setHTML(`<span style="color: ${mainDrawColor}; text-align:left; font-weight:700">${cityData.UC_NM_CTR}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">Average walking time to services:</span>
				<span style="color:${color};font-weight:700"> ${walkingTime(accessValue, true, false)}</span><br>
				<span style="color: ${mainDrawColor}; text-align:left;">% of pop. within 15 min of services:</span>
				<span style="color:${color};font-weight:700"> ${cityfifteenMinProp}%</span><br>`)
			.addTo(map);
		
		selectAll(".mapboxgl-popup-content")
		// .style("background-color", multiValue==="dark"?"black":"rgb(248, 248, 248)")
		.style("background-color", darkMode===true?mainBgColorControls:"rgb(248, 248, 248)")
		// .style("fill", multiValue==="dark"?"#ccc":"black")
		.style("fill", darkMode===false?"#ccc":mainBgColorControls)
		.style("border", `${borderWidthTooltip}px solid ${mainBorderColor}`)
        .style("box-shadow", `${darkMode===true?"none":boxShadow}`)
    }
</script>

{#if $instructions===true && $infoPopup===false}
	{#if selectedPage.label==="UIDescriptionSearch"}
		<div style="border:4px solid {mainSpecialColor}; border-radius:3px; position: absolute; transform:translate({innerWidth>400?innerWidth-(headerItemsMargins+231):innerWidth-(15+231)}px, {$showGlobalTick?21+85:34+85}px); margin:13px; width:213px; height:40px"></div>
	{/if}
    <!-- <div id="infoPopup" 
         style="transform:translate({innerWidth*0.04}px, {innerHeight*0.12}px);
                background-color: {mainBgColorControls};
                color: {mainDrawColor};"> -->
        <div id="infoPopup" 
            style="height:{boxHeight}px;
					right:{headerItemsMargins}px;
                    top:{boxyOffset}px;
					left:{headerItemsMargins}px;
					max-width:{boxWidth}px;
                    background-color: {mainBgColorControls};
                    color: {mainDrawColor};
					border: {borderWidthBoxes}px solid {mainBorderColor};
                    box-shadow: {darkMode===true?"none":boxShadow};
					border-radius:3px;
					text-align: center;
					display: table">
			<div style="text-align:right;">
				<button class="closeButton" 
							style="background-color: {mainBgColorControls};
							color: {mainDrawColor};
							top: 3px;
							right:10px;
							font-size:{innerWidth>500?14:10}px;
							border: 0px solid {mainBorderColor}" on:click={()=>{
								instructions.set(false)
								}}>X
				</button>
			</div>
			<div style="text-align: {innerWidth<640?"left":"justify"};display: table-cell;
			vertical-align: middle;">
				<p style="color:{darkMode===true?"white":mainTitleColor};font-weight:500px;font-size:{innerWidth<500?18.8:20}px;">
					{@html selectedPage.text}
				</p>
				{#if selectedCityName!==null&&selectedPage.label!=="consoleDescription"}
					<DistPlot data = {countryData} {mainDrawColor} {mainSvgColor} {mainSpecialColor} {borderWidthTooltip} {mainBorderColor} {mainBgColorControls} {innerWidth} country={selectedCountry} {darkMode} highlightCities={[selectedCityName]} {fifteenMinProp} width={distPlotWidth} axisLabel = {false} {rScale}/>
				{/if}
			<!-- </div> -->
				{#if pageID===0}
						<p style="color:{darkMode===true?"white":mainTitleColor};margin-bottom:0px;opacity:0.7;font-weight:500px;font-size:{innerWidth<500?13.8:15}px;">
							Want to get more personalized insights?
						</p>
						<div style="z-index:10; display:flex;cursor:pointer;position:absolute;"> 
							<div 
							class="citiesSelect"
							style="--background: {mainBgColorControls}; 
								--placeholderColor:{mainDrawColor};
								--itemColor:{mainDrawColor}; 
								--border: {borderWidthSearch}px solid {mainBorderColor};
								--borderFocusColor:{mainSpecialColor};
								--listBackground:{mainBgColorControls};
								--inputFontSize: 14px;
								--inputColor:{mainDrawColor};
								--groupTitleFontSize: 14px;
								--groupTitleColor: {mainDrawColor};
								--groupTitleFontWeight: {700}px;
								--itemHoverBG: {mainSpecialColor};
								--itemHoverColor: {mainBgColor};
								--itemIsActiveBG: {mainSpecialColorActive};
								cursor:pointer;
								box-shadow: {darkMode===true?"none":boxShadow};
								margin-top:5px;
								margin-bottom:5px;
								margin-left:0px;
								"
							>
								<Select 
								inputStyles="cursor: pointer;"
								items={options} 
								{groupBy} 
								placeholder={darkMode===true?"🌆 search for your city...":"🏙️ search for a city..."}
								on:select={(event) => {
									userCity = event.detail.value
									userCityName = event.detail.label
									userCountry = event.detail.country
									// console.log(event.detail)
									// console.log(selectedCity,":",selectedCityName.text)
										// flyToNewCity(map, selectedCity)
										}
									}>
								</Select>
							</div>
						</div>
				{/if}
				<div id="buttons" style='display:flex;justify-content:{innerWidth>640?"left":"center"}; font-size: {innerWidth<400? 14:16}px;margin-top:{buttonsMargin}px'>
					{#if pageID!==0}
						<button 
						class="infoButton"
						style="background-color: {mainBgColorControls};
							color: {selectedPage==="about"?mainSpecialColor:mainDrawColor};
							font-weight:{selectedPage==="about"?700:500}px;
							border: {borderWidthButtons}px solid {selectedPage==="about"?mainSpecialColor:mainBorderColor};
							box-shadow: {darkMode===true?"none":boxShadow};"
						on:click={() => {
							pageID = pageID-1
						}}
						>Previous
						</button>
						<div class="spacer"></div>
					{/if}
					
					{#if pageID!==pages.length-1}
						<button 
						class="infoButton"
						style="background-color: {mainBgColorControls};
							color: {selectedPage==="methods"?mainSpecialColor:mainDrawColor};
							font-weight:{selectedPage==="methods"?700:500}px;
							border: {borderWidthButtons}px solid {selectedPage==="methods"?mainSpecialColor:mainBorderColor};
							box-shadow: {darkMode===true?"none":boxShadow};"
						on:click={() => {
							pageID = pageID+1
						}}
						>Next
						</button>
						<div class="spacer"></div>
						<button 
						class="infoButton"
						style="background-color: {mainBgColorControls};
							color: {selectedPage==="methods"?mainSpecialColor:mainDrawColor};
							font-weight:{selectedPage==="methods"?700:500}px;
							border: {borderWidthButtons}px solid {selectedPage==="methods"?mainSpecialColor:mainBorderColor};
							box-shadow: {darkMode===true?"none":boxShadow};"
						on:click={() => {
							instructions.set(false)
						}}
						>Skip
						</button>
					{:else}
						<div class="spacer"></div>
						<button 
						class="infoButton"
						style="background-color: {mainBgColorControls};
							color: {selectedPage==="methods"?mainSpecialColor:mainDrawColor};
							font-weight:{selectedPage==="methods"?700:500}px;
							border: {borderWidthButtons}px solid {mainSpecialColor};
							box-shadow: {darkMode===true?"none":boxShadow};"
						on:click={() => {
							instructions.set(false)
						}}
						>Explore the app
						</button>
					{/if}
				</div>
			</div>
            <!-- {#if selectedPage==="about"} -->
                
            <!-- <h2 style="color:{darkMode===true?"white":mainTitleColor}">Data-driven framework</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Data sources</h2>
            <p>Two main sources of data are behind this research. <a href="https://www.openstreetmap.org/#map=19/40.71651/-73.99983" target=_blank style="color:{mainSpecialColor}">OpenStreetMap</a> is used to collect data on pedestrian infrastructure and geographically allocated places of interest (POI): hospitals, schools, supermarkets, restaurants, schools, etc. POIs are returned by the OpenStreetMap API as amenity names and their associated geographical location (i.e. longitude and latitude). Pedestrian infrastructure networks are returned by the OpenStreetMap API as networks of nodes and edges, where each node represents a street intersection and each edge represents a segment of road with walkable or bikable features. Next, we group POI types into a set of different categories (see SI for a complete list of amenities and their associated category). Data on population density for every city is retrieved from the European Commission's 2020 <a href="https://ghsl.jrc.ec.europa.eu/download.php?ds=pop" target=_blank style="color:{mainSpecialColor}">Global Human Settlement Layer (GHSL)</a>. This data is retrieved in the form of a grid of 100m by 100m squares and their associated population density values covering the entire world.</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Accessibility analysis</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Calculation of accessibility by population</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Limitations</h2>
            <p>Methods here</p>
            {:else if selectedPage === "stories"}
                <p>Stories here</p>
            {:else if selectedPage === "FAQ"}
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Is your data representative?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Why does my city look bigger than its municipal boundaries?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Why are there blank spots with no data in some cities?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">How often is this data updated?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">How was this application developed?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">Where can I download this data?</h2>
            <p>Methods here</p>
            <h2 style="color:{darkMode===true?"white":mainTitleColor}">How can I replicate this analysis</h2>
            <p>You can replicate this analysis using <a href="https://github.com/lnicoletti/access-world" target=_blank style="color:{mainSpecialColor}">this GitHub repository</a></p>
            {/if} -->
        </div>
    {/if}

    <style>
    
    main {
		/* text-align: center; */
		/* padding: 1em;
		max-width: 240px; */
		margin: 0 auto;
	}

	#infoPoint:hover {
        font-weight: 900;
        cursor: pointer
	}

	#infoPopup {
		position: absolute;
		z-index:100;
		opacity: 0.9;
		padding-left: 4%;
		padding-right: 4%;
		overflow: auto;
        overflow-x:hidden;
		/* overflow-x: hidden; */
		/* transform: translate(10vw, 10vh); */
		/* background-color: rgb(20, 20, 20); */
	}

	/* #infoPopup::-webkit-scrollbar {
		width:5px; 
	}

	#infoPopup::-webkit-scrollbar-track { 
		width:5px;
	} */

	.sliderFlex {
		margin-bottom: 0;
		margin-top:auto
	}
	.infolink:before {
		content: '?';
		display: inline-block;
		font-family: sans-serif;
		font-weight: bold;
		text-align: center;
		width: 1.8ex;
		height: 1.8ex;
		/* font-size: 1.4ex; */
		line-height: 1.8ex;
		border-radius: 1.2ex;
		margin-right: 4px;
		padding: 1px;
		color: grey;
		background: none;
		border: 1px solid grey;
		text-decoration: none;
	}

	.infolink:hover:before {
		color: white;
		background: grey;
		border-color: white;
		text-decoration: none;
	}

	.appTitle {
		font-family: 'Josefin Sans', sans-serif;
		/* font-family: halyard-micro, sans-serif !important; */
		font-weight: 700;
		/* text-transform: uppercase; */
	}

	#infoPoint {
        font-weight: 900;
        font-size: 30px;
		position: absolute;
		text-align: right;
		/* text-align: right; */
		/* text-align: right; */
	}	
	
	#cuspLogo {
		position: absolute;
		text-align: right;
	}

	.weightSlider {
		display: flex;
		flex-direction: column;
		/* font-size: 13px; */
		/* line-height: 0.02em; */
		text-align: left;
		margin-left: 10px;
		max-width: 150px;
		vertical-align: text-bottom;
		margin-bottom: 0;
		margin-top:auto;
	}

	.resetButton {
		max-width: 150px;
		margin-bottom: auto;
		margin-top:40%;
		margin-left: 10px;
		text-transform: uppercase;
		cursor: pointer;
	}

    .infoButton {
		max-width: 200px;
		margin-bottom: auto;
		margin-left: 0px;
        margin-top:20px;
		text-transform: uppercase;
		cursor: pointer;
		margin-top: auto;
		/* font-size: 10px; */
	}

    .spacer {
        width:10px;
    }

    /* .infoButton:hover {
        border-width: 4px;
    } */

	#smartphoneFilterButton {
		max-width: 50px;
		height: 100px;
		cursor: pointer;
		text-transform: uppercase;
	}

	#smartphoneFilterButton span {
		display: inline-block;
    	transform: rotate(90deg) translate(0px, 15px);
		 /* Safari */
		-webkit-transform: rotate(90deg) translate(0px, 15px);

		/* Firefox */
		-moz-transform: rotate(90deg) translate(0px, 15px);

		/* IE */
		-ms-transform: rotate(90deg) translate(0px, 15px);

		/* Opera */
		-o-transform: rotate(90deg) translate(0px, 15px);
	}

	.closeButton {
		position:absolute; 
		max-height:27px;
		font-weight:900;
		cursor:pointer;					
	}

	.label:first-child {
		float: left;
	}
	.label:last-child {
		float: right;
	}
	#console {
		position: absolute;
		/* width: 25vw; */
		/* width: 300px; */
		max-width: 100vw;
		/* margin: 10px; */
		padding: 10px 20px;
		text-align: left;
		opacity: 0.95;
		/* font-size: 15.3px; */
		border-width: 2px;
		/* background-color: white; */
	}

	#access {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */

	#citiesSelect {
      cursor:pointer;
      max-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 16px;
      text-transform: uppercase;
	  /* border-width: 2px; */
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }
	
	.citiesSelect {
      cursor:pointer;
      max-width: 215px;
	  min-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 14px;
      /* text-transform: uppercase; */
	  border-width: 2px;
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }

	/* #citiesSelect:hover {
		background-color: #fbb61a;
	} */

	.mapboxgl-popup-content {
	color: #ccc;
	}

	td {
	color: #ccc;
	border-bottom:1px solid black;
	border-bottom-width: 0px;
	z-index:0
	}

	.tableSep {
	border-left:1px solid #ccc;
	text-align: center;
	z-index:1
	}

	th {
	text-transform: uppercase;
	color: #ccc;
	border: none;
	}

	table, th, td {
	border-collapse: collapse;
	font-size:12px
	}

	.rounded-rect {
	background: black;
	opacity: 0.7;
	border-radius: 10px;
	box-shadow: 0 0 50px -25px black;
	}
	
	.flex-center {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.flex-center.left {
	left: 0px;
	}
	
	.flex-center.right {
	right: 0px;
	}
	
	.sidebar-content {
	position: absolute;
	width: 95%;
	height: 95%;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 32px;
	color: #ccc;
	}
	
	.sidebar-toggle {
	position: absolute;
	width: 1.3em;
	height: 1.3em;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.sidebar-toggle.left {
	right: -1.5em;
	}
	
	.sidebar-toggle.right {
	left: -1.5em;
	}
	
	.sidebar-toggle:hover {
	color: orange;
	cursor: pointer;
	}
	
	.sidebar {
	transition: transform 1s;
	z-index: 1;
	width: 400px;
	height: 100%;
	}
	
	/*
	The sidebar styling has them "expanded" by default, we use CSS transforms to push them offscreen
	The toggleSidebar() function removes this class from the element in order to expand it.
	*/
	.left.collapsed {
	transform: translateX(-395px);
	}
	
	.right.collapsed {
	transform: translateX(395px);
	}
</style>